import React, {useRef, useEffect, useState} from 'react'
import './KitImage.css'
const KitImage = () => {
    const [isVisible, setIsVisible] = useState(false);

    const textRef = useRef(null);
  // Intersection Observer for fade-in text
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting); // Set visibility based on intersection
      },
      {
        threshold: 0.5, // Trigger when 50% of the element is visible
      }
    );

    const textElement = textRef.current;
    if (textElement) observer.observe(textElement);

    return () => {
      if (textElement) observer.unobserve(textElement);
    };
  }, []);

  return (
    <section className='kit_image'>
                <div className='container'>
                <p ref={textRef}
              className={`fade-in-text ${isVisible ? "visible" : ""}` }>IN KIT</p>
                    <div className='row'>
                        <div className='kit_wrapper d-inline d-lg-flex justify-content-between '>
                                <div className='kit_box'>
                                        <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/diary.svg" alt="Brand self-audit kit diary and pen" className=''/>

                                        <p>Diary & Pen</p>
                                </div>

                                <div className='kit_box'>
                                        <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/tshirt.svg" alt="Brand self-audit kit T-shirt" className=''/>

                                        <p>T-Shirt</p>
                                </div>
                        </div>
                    </div>
                </div>
    </section>
  )
}

export default KitImage
